'use strict';

class AuthView {
  constructor(api, onAuthenticated) {
    this.api = api;
    this.onAuthenticated = onAuthenticated;
    this.authScreen = document.getElementById('auth-screen');
    this.gameScreen = document.getElementById('game-screen');
    this.loginForm = document.getElementById('login-form');
    this.registerForm = document.getElementById('register-form');
    this.message = document.getElementById('auth-message');
    this.loginTab = document.getElementById('login-tab');
    this.registerTab = document.getElementById('register-tab');
    this.bind();
  }

  bind() {
    this.loginTab.addEventListener('click', () => this.showMode('login'));
    this.registerTab.addEventListener('click', () => this.showMode('register'));
    this.loginForm.addEventListener('submit', (event) => this.submitLogin(event));
    this.registerForm.addEventListener('submit', (event) => this.submitRegister(event));
  }

  showMode(mode) {
    const login = mode === 'login';
    this.loginForm.classList.toggle('hidden', !login);
    this.registerForm.classList.toggle('hidden', login);
    this.loginTab.classList.toggle('active', login);
    this.registerTab.classList.toggle('active', !login);
    this.message.textContent = '';
  }

  setBusy(form, busy) {
    for (const control of form.elements) control.disabled = busy;
  }

  async submitLogin(event) {
    event.preventDefault();
    const form = event.currentTarget;
    const data = new FormData(form);
    this.setBusy(form, true);
    this.message.textContent = '';
    try {
      const payload = await this.api.login({
        username: data.get('username'),
        password: data.get('password')
      });
      this.showGame(payload.user);
    } catch (error) {
      this.message.textContent = error.message || '登录失败';
    } finally {
      this.setBusy(form, false);
    }
  }

  async submitRegister(event) {
    event.preventDefault();
    const form = event.currentTarget;
    const data = new FormData(form);
    this.setBusy(form, true);
    this.message.textContent = '';
    try {
      const payload = await this.api.register({
        username: data.get('username'),
        password: data.get('password'),
        confirmPassword: data.get('confirmPassword')
      });
      this.showGame(payload.user);
    } catch (error) {
      this.message.textContent = error.message || '注册失败';
    } finally {
      this.setBusy(form, false);
    }
  }

  showGame(user) {
    this.authScreen.classList.add('hidden');
    this.gameScreen.classList.remove('hidden');
    this.onAuthenticated(user);
  }

  showAuth(message) {
    this.gameScreen.classList.add('hidden');
    this.authScreen.classList.remove('hidden');
    this.showMode('login');
    this.message.textContent = message || '';
  }

  async initialize() {
    try {
      const payload = await this.api.session();
      this.showGame(payload.user);
    } catch (error) {
      this.showAuth(error.status === 0 ? '无法连接服务端，请稍后重试' : '');
    }
  }
}

module.exports = AuthView;
